import { ActionButton } from '@adobe/react-spectrum';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import User from '@spectrum-icons/workflow/User';

export function BreadCrumbAuthorLinkButtons(props) {
    // `source` arrives already brand-cased (getDeckSourceName) — don't re-case
    // it here or names like MythicHub and TappedOut get flattened.
    const label = props.source ? `${props.source} profile` : 'Profile';

    return (
        <ActionButton
            isDisabled={props?.isDisabled}
            aria-label={label}
            onPress={() => {
                logEvent(getAnalytics(), 'preview_open_author', { url: props.url });
                window.open(props.url, `_blank`);
            }}
        >
            <span className="bcBtnLabel">{label}</span>
            <User />
        </ActionButton>
    );
}
